/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/naming-convention */
import { HStack, Select, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Branch } from '../../../questionnaireTemplate.enums';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { formElementSchema } from '../../schemas/formElement.schema';

const DEFAUlT_BRANCHES: Branch[] = [];
const INLINE_SELECT_PROPS = {
  size: 'sm',
  variant: 'filled',
  width: 'fit-content',
  minW: 'unset',
  mx: 1,
  pl: 1,
  cursor: 'pointer',
} as const;

const path = 'preferredAnswer';
export const QuestionExpectedBranch = React.memo(function QuestionExpectedBranch({ elementId }: { elementId: string }) {
  const type = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(elementId, 'questionType'));
  const branches = formElementSchema[type]?.branches ?? DEFAUlT_BRANCHES;
  const valueSelector = React.useCallback((state) => state.getElementValue(elementId, path), [elementId]);
  const value = QuestionnaireTemplateStore.useStoreState(valueSelector) || branches[0];
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);
  const { t } = useTranslation('questionnaireTemplate');

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      updateValue({ id: elementId, path, value: e.target.value });
    },
    [elementId, updateValue],
  );

  return (
    <HStack>
      <Text fontSize="sm">{t('modal.expectedAnswer')}</Text>
      <Select {...INLINE_SELECT_PROPS} value={value} textTransform="capitalize" onChange={handleChange}>
        {branches.map((branch, index) => (
          <option key={branch} value={branch}>
            {t(`formBuilder.schema.yesno.branches.${index}`)}
          </option>
        ))}
      </Select>
    </HStack>
  );
});
